import {
  UPDATE_PRIMARY_FOOTER,
  SET_HEADER_CLOSE,
  SET_APP_LOADING,
  CLEAR_CONFIRMATION,
  UPDATE_CONFIRMATION_SUCCESS,
  HIDE_OVERLAY,
  SHOW_OVERLAY,
} from '../Types';

export const updatePrimaryFooter = (content) => ({ type: UPDATE_PRIMARY_FOOTER, content });
export const setHeaderClose = (payload) => ({ type: SET_HEADER_CLOSE, payload });
export const setAppLoading = (payload) => ({ type: SET_APP_LOADING, payload });

export const updateConfirmation = (payload) => ({ type: UPDATE_CONFIRMATION_SUCCESS, msg: payload });
export const clearConfirmation = () => ({ type: CLEAR_CONFIRMATION });

export const showOverlay = (message = '', showLoader = false) => ({ type: SHOW_OVERLAY, message, showLoader });
export const hideOverlay = () => ({ type: HIDE_OVERLAY });
